import {cx} from "emotion";
import * as React from "react";

import "./inline-amount-form.scss";

import {bindInput}    from "@Common/react/bind-input";
import {cs}           from "@Common/react/chain-services";
import {OnMounted}    from "@Common/react/on-mounted";
import {Static2}      from "@Common/react/static-2";
import {UseState}     from "@Common/react/use-state";
import {formatMoney1} from "@Common/ui-components/language/format-money";

export const InlineAmountForm = ({amount, readOnly, onChange}) => cs(
    ["editing", (_, next) => UseState({
        // initValue: i===0,
        next,
    })],
    ({editing}) => !editing.value ? (
        <div className="inline-amount-form-33d inline-amount-form viewing">
            <div className="value" xd-qa-type="text" xd-qa-name="Amount">
                {formatMoney1(amount)}
            </div>
            <i
                className={cx("fa fa-pencil", {disabled: readOnly})}
                onClick={() => !readOnly && editing.onChange(true)}
                xd-qa-type="icon"
                xd-qa-name="Pencil"
            />
        </div>
    ) : cs(
        ["amount", (_, next) => UseState({
            initValue: amount,
            next,
        })],
        ["ref", (_, next) => Static2({next})],
        ["accept", (_, next) => next((v) => {
            onChange(v);
            editing.onChange(false);
        })],
        ({amount, ref, accept}) => (
            <div className="inline-amount-form-33d inline-amount-form editing">
                <div className="dollar-sign">
                    $
                </div>
                <input {...{
                    ...bindInput(amount),
                    onKeyDown: (e) => {
                        if (e.key === "Enter") {
                            accept(amount.value);
                        }
                    },
                    ref: ref.set,
                }}
                    xd-qa-type="text_field"
                    xd-qa-name="Amount"
                />

                {OnMounted({
                    action: () => {
                        ref.get().focus();
                        ref.get().select();
                    },
                })}

                <i {...{
                    className: "fa fa-check",
                    onClick: () => accept(amount.value),
                }}
                    xd-qa-type="icon"
                    xd-qa-name="Check"
                />
                <i {...{
                    className: "fa fa-close",
                    onClick: () => editing.onChange(false),
                }}
                    xd-qa-type="icon"
                    xd-qa-name="Close"
                />
            </div>
        ),
    ),
);
